import React from 'react';

/**
 * Replaces text wrapped in asterisks (*) with bold elements.
 * This function takes a string and identifies parts of the text
 * enclosed in asterisks (e.g., *bold text*) and wraps those parts
 * in <b> tags to make them bold.
 *
 * @param {string} text - The input string, which may contain text wrapped in asterisks to denote bold text.
 * @returns {(string | React.ReactNode)[]} - An array containing the original text and React elements.
 *     Text that is wrapped in asterisks will be replaced with <b> tags for bold formatting.
 */
export const formatBoldText = (text: string): (string | React.ReactNode)[] => {
  const parts = text.split(/(\*[^*]+\*)/g); // Split text by *bold* markers

  return parts.map((part, index) => {
    if (part.startsWith('*') && part.endsWith('*')) {
      return React.createElement('b', { key: index }, part.slice(1, -1)); // Wrap in <b> tag
    }
    return part;
  });
};
